import CommonContainer from "../Container/CommonContainer"
import React, { useState, useRef, useEffect } from 'react';
import * as DocumentService from '../../Services/Document/DocumentService';
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { allowedTypes } from "../../Common/CommonVariables";
import { FaAngleDown, FaAngleRight, FaDownload } from "react-icons/fa";

const DocumentCard = ({ title, description, downloadLink }) => {

  const [isExpanded, setIsExpanded] = useState(false);
  const [showReadMore, setShowReadMore] = useState(false);
  const textRef = useRef(null);
  const maxLines =2

  useEffect(() => {
    const checkTextOverflow = () => {
      if (textRef.current) {
        const lineHeight = parseInt(window.getComputedStyle(textRef.current).lineHeight);
        const maxHeight = lineHeight * maxLines;
        const actualHeight = textRef.current.scrollHeight;
        
        if (actualHeight > maxHeight) {
          setShowReadMore(true);
        } else {
          setShowReadMore(false);
        }
      }
    };

    checkTextOverflow();
    window.addEventListener('resize', checkTextOverflow);
    
    return () => window.removeEventListener('resize', checkTextOverflow);
  }, [description, maxLines]);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const handleDownload = () => {
    // Check if downloadLink exists before attempting to open it
    if (downloadLink) {
      // Open the link in a new tab
      window.open(downloadLink, '_blank', 'noopener,noreferrer');
    } else {
      alert('Download link is not available for this document');
    }
  };

  return (
    <div className="col-12 col-md-4 mb-1 shadow bg-white p-1 rounded" style={{width:'25%', marginLeft: '10px'}}>
      {/* <div className="card border-0" > */}
        {/* <div className="card h-100 bg-light border-0"></div> */}
        <div className="card-body p-0" style={{width: '230px', padding: '5px', fontSize: 'small'}}>
          <div className="d-flex justify-content-between align-items-center">
            <strong className="text-secondary pl-2" >{title}</strong>
            <FaDownload
              onClick={handleDownload}
              style={{
                cursor: downloadLink ? 'pointer' : 'not-allowed',
                color: 'green',
              }}
              disabled={!downloadLink}
            />
          </div>
          <div className="border-top p-2">
            <p ref={textRef}
              className={`mb-0 text-left ${!isExpanded ? 'text-truncate-custom' : ''}`}
              style={{
                display: '-webkit-box',
                WebkitLineClamp: !isExpanded ? maxLines : 'none',
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                lineHeight: '1.5',
                fontSize: 'x-small'
              }}
            >{description}</p>
            {showReadMore && (
              <button
                onClick={toggleExpanded}
                className="btn btn-link p-0 text-decoration-none"
                style={{ 
                  color: '#007bff', 
                  fontSize: 'x-small',
                  cursor: 'pointer',
                  border: 'none',
                  background: 'none'
                }}
              >
                {isExpanded ? 'Show less' : 'Show More'}
              </button>
            )}
          </div>
        </div>
      {/* </div> */}
    </div>
  );
};

const DocumentSection = ({ title, documents }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleSection = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="mb-2">
      {/* <div 
        className="card"
        style={{ overflow: 'hidden' }}
      > */}
        {/* Accordion Header */}
        <div 
          className="card-header bg-light d-flex justify-content-between align-items-center" 
          style={{ cursor: 'pointer' }}
          onClick={toggleSection}
        >
          <span className="fw-bold">{title}</span>
          <span>{isExpanded ? <FaAngleDown/> : <FaAngleRight/>}</span>
        </div>
        
        {/* Collapsible Content */}
        {isExpanded && (
          <div className="card-body p-3">
            <div className="row">
              {documents && documents.length > 0 ? (
                documents.map((doc, index) => (
                  <DocumentCard 
                    key={index}
                    title={doc.Title}  // Changed from title to match DocumentCard props
                    description={doc.Document_Description}   // Changed from subtitle to match DocumentCard props
                    downloadLink={doc.Document_Url}
                  />
                ))
              ) : (
                <div className="col-12 text-center p-3">
                  <p className="text-muted">No documents available</p>
                </div>
              )}
            </div>
          </div>
        )}
      {/* </div> */}
    </div>
  );
};

const MHL_DocumentModalComponent = (props) => {
  const {handleNewDocumentModalClose, selectedPartnerDet} = props

  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  const fileInputRef = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [documentsList, setDocumentsList] = useState([]);
  const [documentCategoryList, setDocumentCategoryList] = useState([]);

  useEffect(() => {
    // Only fetch when component mounts, not on every importantDocuments change
    const fetchDocuments = async () => {
      try {      
        const documentCategory = await fetchAllDocumentCategory();
        setDocumentCategoryList(documentCategory);
  
        const documentList = await fetchActiveDocumentList();
        setDocumentsList(documentList);
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    };
    
      fetchDocuments();
    }, []); 

  const fetchAllDocumentCategory = () =>{
    DocumentService.GetAllDocumentCategory()
    .then(({data}) =>{
      //debugger;
        if(data.IsSuccess){
          //console.log("category list", data.Data)
          setDocumentCategoryList(data.Data);
        }
        else{
          setDocumentCategoryList([]);
        }
      })
      .catch(() => toast.error("Something went wrong during creation."))
      .finally(() => { });;
  }

  const fetchActiveDocumentList = () =>{
    DocumentService.GetActiveDocumentList()
    .then(({data}) =>{
        if(data.IsSuccess){
          setDocumentsList(data.Data);
          //console.log("section documents", data)
        }
        else{
          setDocumentsList([]);
        }
      })
      .catch(() => toast.error("Something went wrong during creation."))
      .finally(() => { });
  }

  const handleMainFileUpload = (event) => {
    //debugger;
    const file = event.target.files[0];
    const maxFileSize = 5 * 1024 * 1024; // 5MB
    if (file) {
      if (!allowedTypes.includes(file.type) || file.size > maxFileSize) {
        toast.error('File is either unsupported or exceeds the 5MB limit.');
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
        return;
      }

      // You can add logic here to determine which section/document to update
      setSelectedFiles(file);
    }
  };

  const InsertNewDocumentDet = (data) =>{
    const fullName = selectedFiles.name;              // e.g. "contract.pdf"
    const documentName = fullName.substring(0, fullName.lastIndexOf('.')) || fullName;

    const extension = selectedFiles.name.split('.').pop();         // "pdf"
    const documentType = "." + extension.toLowerCase();
    
    //data.Document_Purpose = 'important'
    data.PartnerId = selectedPartnerDet.Partnerid;
    data.Partner_Code = selectedPartnerDet.Partner_Code;
    data.Document_FileType = documentType;
    data.Document_Name = documentName;

    DocumentService.InsertNewDocumentDet(data)
          .then(({ data }) => {
            if (data.IsSuccess) {
              toast.success("Document saved successfully!");
              // getImportantDocumentByPartnerCode(selectedPartnerDet.Partner_Code);
              fetchActiveDocumentList();
              handleCancel();
            } else {
              toast.error(data.ResponseMessage);
            }
          })
          .catch(() => toast.error("Something went wrong during creation."))
          .finally(() => { });
  }

  const onSubmit = (formDetails) =>{
    //debugger;
      const formData = new FormData();
      formData.append('file', selectedFiles);

      DocumentService.AddNewDocument(formData)
          .then(({ data }) => {
            if (data.IsSuccess) {
              formDetails.Document_Url = data.Data;
              InsertNewDocumentDet(formDetails);
            } else {
              toast.error(data.ResponseMessage);
            }
          })
          .catch(() => toast.error("Something went wrong during creation."))
          .finally(() => { });
  }

  const handleCancel = () =>{
    reset();
  }

  return (
    <>
      <CommonContainer >
        <div className="modal-backdrop">
          <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-lg custom-modal" style={{maxWidth: '950px'}} role="document">
              <div className="modal-content mb-0 p-0">
                <div className="modal-header p-2-5">
                  <h5 className="modal-title">Documents</h5>
                  <button type="button" className="btn-close" onClick={handleNewDocumentModalClose}></button>
                </div>
                <div className="modal-body p-1">
                  <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                    <div className="container" style={{ fontSize: "13px" }}>
                        <div className="d-flex align-items-center gap-2 mb-2" style={{ fontSize: "13px" }} >
                          <label className="fw-bold mb-0-5">Upload Document :</label>
                          <input className="form-control" style={{ width: '250px' }} type="file"
                            ref={fileInputRef}
                            accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.gif,.webp,.bmp,.svg,.eml"
                            {...register("Document_File", { required: "Please select document" })}
                            onChange={handleMainFileUpload}
                          />
                          {errors.Document_File && <p className="text-danger required_error">{errors.Document_File.message}</p>}
                          <div className="alert alert-info p-2 mt-1 pt-2" style={{ fontSize: '9px', maxWidth: '350px', marginBottom: '4px' }}>
                            <strong>Note:</strong> You can upload a maximum of 1 files(less than 5MB).<br />
                            Accepted file: <code>.pdf</code>, <code>.doc</code>, <code>.docx</code>, <code>.jpeg</code>, <code>.jpg</code>, <code>.png</code>, <code>.gif</code>, <code>.webp</code>, <code>.bmp</code>, <code>.svg</code>, <code>.eml</code>
                          </div>
                        </div>

                        <ul className="list-group pl-3 pb-2 pt-1 col-md-6" >
                          {selectedFiles && selectedFiles.length > 0 ? (
                            selectedFiles.map((file) => (
                              <li key="" className="list-group-item d-flex align-items-center" >
                                {file.name}
                              </li>
                            ))
                          ) : (
                            null
                          )}
                        </ul>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="fw-bold required mb-0-5">Title</label>
                              <input type="text" className="form-control" placeholder="Enter Case Origin" {...register("Title", { required: "title is required" })} />
                              {errors.Title && <p className="text-danger required_error">{errors.Title.message}</p>}
                          </div>
                          <div className="col-md-6">
                            <label className="form-label required fw-bold mb-0-5">Document Category:</label>
                            <div className="case-select-wrapper">
                              <select className="form-select case-dropdown" defaultValue={""} {...register("Document_Category_Id", { required: "Document category is required" })}>
                                <option value="">Select Document Category</option>
                                {documentCategoryList && documentCategoryList.map((item, index) => (
                                  <option key={index} value={item.Document_Category_Id}>
                                    {item.Document_Category_Name}
                                  </option>
                                ))}
                              </select>
                              {errors.Document_Category_Id && (<p className="text-danger required_error"> {errors.Document_Category_Id.message} </p>)}
                            </div>
                          </div>
                          
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label required fw-bold">Description</label>
                            <textarea 
                            className="form-control" 
                            rows="3" 
                            placeholder="Enter a description for the case" 
                            {...register("Document_Description", {required: "Document Description is required"})}
                            ></textarea>
                            {errors.Document_Description && <p className="text-danger required_error">{errors.Document_Description.message}</p>}
                          </div>
                        </div>
                      </div>

                    <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                      <button type="button" className="btn btn-danger" onClick={handleCancel}>Cancel</button>
                      <button type="submit" className="btn btn-primary">Save</button>
                    </div>

                  </form>
                  <hr></hr>
                  <div>
                    {documentCategoryList && documentCategoryList.map((docs, index) => {
                    // Filter documents for this specific category
                    const categoryDocuments = (documentsList || []).filter(doc => 
                      doc.Document_Category_Id === docs.Document_Category_Id
                    );
                    
                    // Only render if there are documents for this category
                    if (categoryDocuments.length === 0) return null;
                    
                    return (
                      <DocumentSection 
                        key={docs.Document_Category_Id} // Use ID instead of index for better key
                        title={docs.Document_Category_Name}
                        documents={categoryDocuments} // Pass filtered documents
                      />
                    );
                  })}

                  {/* Show message if no documents are available at all */}
                  {(!documentCategoryList || documentCategoryList.length === 0) && (
                    <div className="alert alert-info text-center">
                      No documents are currently available.
                    </div>
                  )}
                  </div>
                    <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                      <button type="button" className="btn btn-danger" onClick={handleNewDocumentModalClose}>Close</button>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CommonContainer>
    </>
  );
};

export default MHL_DocumentModalComponent;